import React from 'react';
import { useContent } from '../../hooks/useContent';

export const AboutSection: React.FC = () => {
  const { content } = useContent();
  
  if (!content?.mission) return null;

  return (
    <section className="py-20 bg-slate-900">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl font-bold mb-6 text-white">
            {content.mission.title}
          </h2>
          <p className="text-xl text-gray-400 mb-8">
            {content.mission.subtitle}
          </p>
          <div className="bg-slate-800 p-8 rounded-2xl border border-slate-700">
            <p className="text-lg text-gray-300 leading-relaxed mb-6">
              A DevDriven nasce com a missão de entregar soluções digitais de alta qualidade, 
              mais rápido e com menor custo. Nosso diferencial está no time formado exclusivamente 
              por especialistas com competências múltiplas.
            </p>
            <p className="text-lg text-gray-300 leading-relaxed">
              Profissionais que unem conhecimento em tecnologia, visão de negócio e capacidade de gestão, 
              eliminando a necessidade de estruturas caras e ineficientes que não agregam valor real ao seu projeto.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};